import styled from 'styled-components'

interface ChartSelectorProps {
  isActive?: boolean
  size?: 'sm' | 'md'
}

export const Container = styled.div<ChartSelectorProps>`
  display: flex;
  justify-content: center;
  @media (max-width: 430px) {
    max-width: ${({ size }) => (size === 'md' ? '60px' : '40px')};
  }
`

export const Input = styled.input<ChartSelectorProps>`
  display: none;

  &:focus ~ label {
    border: ${({ theme, isActive }) => (isActive ? theme.colors.secondaryL3 : 'transparent')};
  }
`

export const ChartSelectorButton = styled.label<ChartSelectorProps>`
  cursor: pointer;
  width: ${({ size }) => (size === 'md' ? '80px' : '60px')};
  height: ${({ size }) => (size === 'md' ? '108px' : '88px')};
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  background-color: ${({ theme, isActive }) => (isActive ? `${theme.colors.secondaryL1}bf` : 'transparent')};
  border: 1px solid ${({ theme, isActive }) => (isActive ? theme.colors.secondaryL3 : 'transparent')};

  &:hover {
    background-color: ${({ theme, isActive }) =>
      isActive ? `${theme.colors.secondaryL1}b3` : `${theme.colors.secondaryL1}26`};
  }

  &:active {
    background-color: ${({ theme, isActive }) =>
      isActive ? theme.colors.secondaryL1 : `${theme.colors.secondaryL1}52`};
  }

  @media (max-width: 430px) {
    width: ${({ size }) => (size === 'md' ? '70px' : '50px')};
    height: ${({ size }) => (size === 'md' ? '110px' : '80px')};
  }

  @media (max-height: 800px) {
    width: ${({ size }) => (size === 'md' ? '70px' : '50px')};
    height: ${({ size }) => (size === 'md' ? '103px' : '75px')};
    padding: 4px 6px 0 6px;
  }
`

// Wraps the image so the loading overlay can be absolutely positioned over it,
// matching the image's rounded corners and footprint.
export const ChartImageWrapper = styled.div`
  position: relative;
  display: flex;
`

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.55);
  color: ${({ theme }) => theme.colors.neutralL5};
`

export const ChartImage = styled.img<ChartSelectorProps>`
  max-width: ${({ size }) => (size === 'md' ? '60px' : '44px')};
  min-width: ${({ size }) => (size === 'md' ? '60px' : '44px')};
  height: auto;
  border-radius: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  object-fit: cover;
  object-position: center;

  @media (max-width: 430px) {
    max-width: ${({ size }) => (size === 'md' ? '58px' : '38px')};
    max-height: ${({ size }) => (size === 'md' ? '58px' : '38px')};
    min-width: ${({ size }) => (size === 'md' ? '58px' : '38px')};
    min-height: ${({ size }) => (size === 'md' ? '58px' : '38px')};
  }
`

export const ChartLabel = styled.p<ChartSelectorProps>`
  ${({ theme }) => theme.fonts.infoSM}
  text-align: center;
  width: 100%;
  color: ${({ theme }) => theme.colors.neutralL5};
  /* margin: 4px 0; */
  margin: ${({ size }) => (size === 'md' ? '4px 0' : '2px 0')};
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 430px) {
    ${({ theme }) => theme.fonts.infoXS}
  }

  /* @media (max-height: 800px) {
    margin-top: 3px;
  } */
`

// Clamps long chart names (e.g. user charts) to 2 lines with an ellipsis so they
// don't overflow the fixed-size selector. Short labels are unaffected.
export const ChartLabelText = styled.span`
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
`
